module.exports = __webpack_public_path__ + "static/img/bcg.993889ae.png";